import React from 'react';
import dayjs from 'dayjs';

import { Popup, EnhancedTable } from 'components';

const formatTime = (row, col) => dayjs(row[col])?.format('HH:mm');
const formatTraffic = (row, col) => (row[col]/60).toFixed(2);
const columns = [
  { name: 'TimeStamp', label: 'Time', format: formatTime },
  { name: 'InternetRX', label: 'InternetRX', format: formatTraffic },
  { name: 'InternetTX', label: 'InternetTX', format: formatTraffic },
  { name: 'IntranetRX', label: 'IntranetRX', format: formatTraffic },
  { name: 'IntranetTX', label: 'IntranetTX', format: formatTraffic },
  { name: 'CPU', label: 'CPU' },
];

const NetTraffic = ({instance, onClose}) => {
  return (
    <Popup
      open={Boolean(instance)}
      onClose={onClose}
      title={`Net traffic for instance ${instance}`}
      styles={{width: 'auto'}}
    >
      <EnhancedTable
        stickyHeader
        columns={columns}
        idColumn="TimeStamp"
        dataUrl= {`/systems/rlrtraffic/${instance}`}
        multiPage={false}
      />
    </Popup>
  );
};

export default NetTraffic;
